/* global axios */
import ApiClient from './ApiClient';

class VoiceNumbersAPI extends ApiClient {
  constructor() {
    super('voice_numbers', { accountScoped: true });
  }

  // Both answer with the same Voice::Health payload: where the webhooks point today.
  health(id) {
    return axios.get(`${this.url}/${id}/health`);
  }

  // Minutes from our own calls, money from Twilio, over the same window.
  usage(id, { period } = {}) {
    return axios.get(`${this.url}/${id}/usage`, { params: { period } });
  }

  provision(id) {
    return axios.post(`${this.url}/${id}/provision`);
  }
}

export default new VoiceNumbersAPI();
